<app-alarm-list
    [alarms]="alarms"
    [project]="project"
    (rowClick)="onAlarmClick($event)"
    (deleteClick)="onAlarmDelete($event)"
    (duplicateClick)="onAlarmDuplicate($event)"
>
</app-alarm-list>
<div class="add-button">
    <button
        mat-fab
        id="add-alarm-button"
        aria-label="add alarm"
        (click)="addAlarm()"
        [@animate]="{ value: '*', params: { delay: '300ms', scale: '.2' } }"
    >
        <mat-icon>add_circle_outline</mat-icon>
    </button>
</div>
